import React, { useState } from "react";
import { Rating } from "react-simple-star-rating";
import { Link } from "react-router-dom";
import {FaUserCheck, FaTrash } from "react-icons/fa";
import { GrUserExpert } from "react-icons/gr";
import dashprofile from "../../../../../../images/agency/agent/3.jpg";
import "./AgentListGrid.css";

const AgentListGrid = () => {
  const decor = {
    textDecoration: "none",
  };

  const [rating, setRating] = useState(0);

  const handleRating = (rate: number) => {
    setRating(rate);
    // other logic
  };
  return (
    <div>
      <div className="ag-container">
        <div className="agent-list-content">
          <div className="ag-position">
            <img className="ag-img" src={dashprofile} alt="" />
            <div className="pos">
              <div className="testy-rating">
                <Rating
                  className="testy-rating"
                  size={15}
                  onClick={handleRating}
                  ratingValue={rating} /* Available Props */
                  fillColor={"#f1a545"}
                  fillColorArray={["3"]}
                />
              </div>
              <h3>Excellent</h3>
            </div>
          </div>
          <div className="ag-grid">
            <div className="ag-grid-mini">
              <div className="ag-grid-inner">
                <h3>Liza Rose</h3>
                <h6>Mavers RealEstate agency</h6>
              </div>
              <GrUserExpert className="check" />
            </div>
            <div className="ag-mini">
              <h3>
                Listings <span>24</span>
              </h3>
              <h3>
                Reviews <span>18</span>
              </h3>
              <h3>
                Bookings <span>124</span>
              </h3>
            </div>
            <div className="ag-flex">
              <Link style={decor} to="/agentsingle" className="ag-profile">
                View Profile
              </Link>
              <div className="ag-flex-right">
                <Link className="flex-icon" style={decor} to="/">
                  <FaUserCheck />
                </Link>
                <Link className="flex-icon" style={decor} to="/">
                  <FaTrash />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="agent-list-content">
          <div className="ag-position">
            <img className="ag-img" src={dashprofile} alt="" />
            <div className="pos">
              <div className="testy-rating">
                <Rating
                  className="testy-rating"
                  size={15}
                  onClick={handleRating}
                  ratingValue={rating} /* Available Props */
                  fillColor={"#f1a545"}
                  fillColorArray={["3"]}
                />
              </div>
              <h3>Excellent</h3>
            </div>
          </div>
          <div className="ag-grid">
            <div className="ag-grid-mini">
              <div className="ag-grid-inner">
                <h3>Liza Rose</h3>
                <h6>Mavers RealEstate agency</h6>
              </div>
              <GrUserExpert className="check" />
            </div>
            <div className="ag-mini">
              <h3>
                Listings <span>24</span>
              </h3>
              <h3>
                Reviews <span>18</span>
              </h3>
              <h3>
                Bookings <span>124</span>
              </h3>
            </div>
            <div className="ag-flex">
              <Link style={decor} to="/listings" className="ag-profile">
                View Profile
              </Link>
              <div className="ag-flex-right">
                <Link className="flex-icon" style={decor} to="/">
                  <FaUserCheck />
                </Link>
                <Link className="flex-icon" style={decor} to="/">
                  <FaTrash />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="agent-list-content">
          <div className="ag-position">
            <img className="ag-img" src={dashprofile} alt="" />
            <div className="pos">
              <div className="testy-rating">
                <Rating
                  className="testy-rating"
                  size={15}
                  onClick={handleRating}
                  ratingValue={rating} /* Available Props */
                  fillColor={"#f1a545"}
                  fillColorArray={["3"]}
                />
              </div>
              <h3>Excellent</h3>
            </div>
          </div>
          <div className="ag-grid">
            <div className="ag-grid-mini">
              <div className="ag-grid-inner">
                <h3>Liza Rose</h3>
                <h6>Mavers RealEstate agency</h6>
              </div>
              <GrUserExpert className="check" />
            </div>
            <div className="ag-mini">
              <h3>
                Listings <span>24</span>
              </h3>
              <h3>
                Reviews <span>18</span>
              </h3>
              <h3>
                Bookings <span>124</span>
              </h3>
            </div>
            <div className="ag-flex">
              <Link style={decor} to="/listings" className="ag-profile">
                View Profile
              </Link>
              <div className="ag-flex-right">
                <Link className="flex-icon" style={decor} to="/">
                  <FaUserCheck />
                </Link>
                <Link className="flex-icon" style={decor} to="/">
                  <FaTrash />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="agent-list-content">
          <div className="ag-position">
            <img className="ag-img" src={dashprofile} alt="" />
            <div className="pos">
              <div className="testy-rating">
                <Rating
                  className="testy-rating"
                  size={15}
                  onClick={handleRating}
                  ratingValue={rating} /* Available Props */
                  fillColor={"#f1a545"}
                  fillColorArray={["3"]}
                />
              </div>
              <h3>Excellent</h3>
            </div>
          </div>
          <div className="ag-grid">
            <div className="ag-grid-mini">
              <div className="ag-grid-inner">
                <h3>Liza Rose</h3>
                <h6>Mavers RealEstate agency</h6>
              </div>
              <GrUserExpert className="check" />
            </div>
            <div className="ag-mini">
              <h3>
                Listings <span>24</span>
              </h3>
              <h3>
                Reviews <span>18</span>
              </h3>
              <h3>
                Bookings <span>124</span>
              </h3>
            </div>
            <div className="ag-flex">
              <Link style={decor} to="/listings" className="ag-profile">
                View Profile
              </Link>
              <div className="ag-flex-right">
                <Link className="flex-icon" style={decor} to="/">
                  <FaUserCheck />
                </Link>
                <Link className="flex-icon" style={decor} to="/">
                  <FaTrash />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="agent-list-content">
          <div className="ag-position">
            <img className="ag-img" src={dashprofile} alt="" />
            <div className="pos">
              <div className="testy-rating">
                <Rating
                  className="testy-rating"
                  size={15}
                  onClick={handleRating}
                  ratingValue={rating} /* Available Props */
                  fillColor={"#f1a545"}
                  fillColorArray={["3"]}
                />
              </div>
              <h3>Excellent</h3>
            </div>
          </div>
          <div className="ag-grid">
            <div className="ag-grid-mini">
              <div className="ag-grid-inner">
                <h3>Liza Rose</h3>
                <h6>Mavers RealEstate agency</h6>
              </div>
              <GrUserExpert className="check" />
            </div>
            <div className="ag-mini">
              <h3>
                Listings <span>24</span>
              </h3>
              <h3>
                Reviews <span>18</span>
              </h3>
              <h3>
                Bookings <span>124</span>
              </h3>
            </div>
            <div className="ag-flex">
              <Link style={decor} to="/listings" className="ag-profile">
                View Profile
              </Link>
              <div className="ag-flex-right">
                <Link className="flex-icon" style={decor} to="/">
                  <FaUserCheck />
                </Link>
                <Link className="flex-icon" style={decor} to="/">
                  <FaTrash />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="agent-list-content">
          <div className="ag-position">
            <img className="ag-img" src={dashprofile} alt="" />
            <div className="pos">
              <div className="testy-rating">
                <Rating
                  className="testy-rating"
                  size={15}
                  onClick={handleRating}
                  ratingValue={rating} /* Available Props */
                  fillColor={"#f1a545"}
                  fillColorArray={["3"]}
                />
              </div>
              <h3>Excellent</h3>
            </div>
          </div>
          <div className="ag-grid">
            <div className="ag-grid-mini">
              <div className="ag-grid-inner">
                <h3>Liza Rose</h3>
                <h6>Mavers RealEstate agency</h6>
              </div>
              <GrUserExpert className="check" />
            </div>
            <div className="ag-mini">
              <h3>
                Listings <span>24</span>
              </h3>
              <h3>
                Reviews <span>18</span>
              </h3>
              <h3>
                Bookings <span>124</span>
              </h3>
            </div>
            <div className="ag-flex">
              <Link style={decor} to="/listings" className="ag-profile">
                View Profile
              </Link>
              <div className="ag-flex-right">
                <Link className="flex-icon" style={decor} to="/">
                  <FaUserCheck />
                </Link>
                <Link className="flex-icon" style={decor} to="/">
                  <FaTrash />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentListGrid;
